import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RITEL_INVESTOR } from '../../models/investor';
import { MASTER_SID } from '../../models/mastersid';
import { ACCOUNTS } from '../../models/account';
import { PARTS } from '../../models/part';
import { HeaderService } from '../../header.service';
import * as Globals from '../../globals';
import { errorMessage } from '../../globals';
import { PARTISIPAN } from './../../models/partisipan';
declare var $: any;

@Component({
  selector: 'app-investor-detail',
  templateUrl: './investor-detail.component.html',
  styleUrls: ['./investor-detail.component.css']
})
export class InvestorDetailComponent implements OnInit {

  @Input() invId: number;
  @Output() refreshParent = new EventEmitter;
  searchKota: string = '';
  loading: boolean;
  formDelete: number;
  investor: RITEL_INVESTOR;
  mastersid: MASTER_SID;
  vparts: any;
  vpart: any[];
  accounts: ACCOUNTS[];
  account: ACCOUNTS;
  parts: PARTS[];
  partisipan: PARTISIPAN[];
  grpKelamin: any[];
  grpIdentity: any[];
  grpProfession: any[];
  kota: string = '';
  grpKota: any[];
  allpart: any[];
  p:any;
  NAME: string = '';
  provinsi: string = '';
  @Input() userProfile: any;
  @Input() authMenu: any;
  subtab: number = 1;
  modalAccount: boolean;
  @Input() formActive: boolean = false;

  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService) {
    this.toastr.setRootViewContainerRef(vRef);
  }
  ngOnInit() {
    this.accounts = [];
    this.vparts = {};
    this.vpart = [];
    this.grpKota = [];
    this.allpart = [];
    this.newInvestor();
    this.newAccount();
    this.getCds(25);
  }
  loadParent(val: any) {
    this.refreshParent.emit({ invId: this.investor.INV_ID, idtyNo: this.investor.IDTY_NO, mode: val });
  }
  newInvestor() {
    this.investor = new RITEL_INVESTOR(0, null, null, null, null, null, null, null, null, null, null, null, null, null, '1', null, null, this.userProfile.USER_ID);
    this.provinsi = '';
    this.kota = '';
  }
  newAccount() {
    this.account = new ACCOUNTS(0, null, null, null, this.userProfile.USER_ID, null, null, null, null);
  }
  getKota(cgNo: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/cdsparent?cgno=' + cgNo + '&search=' + this.searchKota + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.grpKota = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getKotaProvinsi(cgNo: number, cdCode: string) {
    this.http.get(Globals.serviceUrl + 'ref/cdsparent?cgno=' + cgNo + '&cdcode=' + cdCode + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.grpKota = res.json();
        this.kota = this.grpKota[0].SYS_NAME;
        this.provinsi = this.grpKota[0].PARENT_NAME;
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getCds(cgNo: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/cds?cgno=' + cgNo + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        switch (cgNo) {
          case 25:
            this.grpKelamin = res.json();
            this.getCds(26);
            break
          case 26:
            this.grpIdentity = res.json();
            this.getCds(27);
            break;
          case 27:
            this.grpProfession = res.json();
            if (this.invId > 0) {
              this.editInvestor(this.invId);
            } else {
              this.loading = false;
            }
            break;
          default:
            break;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  editInvestor(id: number) {
    this.http.get(Globals.serviceUrl + 'ritel/investor?id=' + id + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.investor = res.json();
        this.investor.BIRTH_DATE = new Date(this.investor.SBIRTH_DATE);
        this.getKotaProvinsi(24, this.investor.CD_DISTRICT);
        this.getAccount('3');
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getAccount(val: any) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/accounts?invid=' + this.investor.INV_ID + '&intstype=' + val + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.accounts = res.json();
        // console.log(this.accounts);
        for (var i = 0; i < this.accounts.length; i++) {
          if (this.accounts[i].PARTS.NAME == undefined) {
            this.accounts[i].PARTS.NAME = this.accounts[i - 1].PARTS.NAME;
          }
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  saveInvestor() {
    this.loading = true;
    this.investor.SBIRTH_DATE = Globals.formatDate(this.investor.BIRTH_DATE);
    // console.log(this.investor);
    if (this.investor.INV_ID === 0) {
      this.http.post(Globals.serviceUrl + 'ritel/investor', this.investor, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.investor = res.json();
          this.toastr.success('Data berhasil disimpan');
          this.loadParent(1);
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    } else {
      this.http.put(Globals.serviceUrl + 'ritel/investor?id=' + this.investor.INV_ID, this.investor, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.toastr.success('Data berhasil disimpan');
          this.loadParent(1);
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }
  deleteInvestor() {
    this.loading = true;
    if (this.formDelete === 1) {
      this.http.delete(Globals.serviceUrl + 'ritel/investor?id=' + this.investor.INV_ID, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          $('#modal').modal('hide');
          this.toastr.success('Data berhasil dihapus');
          this.loading = false;
          this.loadParent(0);
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    } else {
      var inst = 3;
      if (this.subtab === 2) {
        inst = 2;
      }
      this.http.delete(Globals.serviceUrl + 'ritel/accounts?id=' + this.account.ACCT_ID, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.toastr.success('Data berhasil dihapus');
          this.loading = false;
          this.getAccount(inst);
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }

  }
  getVParts(id: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/parts?id=' + id + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res) => {
        this.vparts = res.json();
        this.vpart.push(this.vparts);
        // console.log(this.vpart);
        // console.log(this.vparts.NAME);
        // this.NAME = this.vparts.NAME;
        // for (var i = 0; i < this.accounts.length; i++) {
        //   this.accounts[i].NAME = this.vparts.NAME;
        // }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getParts(val: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/parts?inst=' + val + '&search=&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res) => {
        this.parts = res.json();
        this.getPartisipan();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getPartisipan() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/parts?inst=67&search=&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res) => {
        this.partisipan = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
    // this.http.get(Globals.serviceUrl + 'ref/parts?inst=7&search=&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
    //   .subscribe((res) => {
    //     // this.partisipan = res.json();
    //     // var merged = Object.assign(this.partisipan, res.json());
    //     var merged = this.partisipan.concat(res.json())
    //     console.log(merged);
    //     this.allpart.push(merged);
    //     console.log(this.allpart);
    //     //this.partisipan.push(res.json());
    //     // console.log(res.json());
    //     this.loading = false;
    //   }, err => {
    //     console.log(err);
    //     this.toastr.error(Globals.errorMessage(err));
    //     this.loading = false;
    //   });
  }

  changeParts(){
    var itemp: any;
    for (var i = 0; i < this.parts.length; i++) {
      if (this.parts[i].PA_ID == this.account.ISSUED_BY) {
        itemp = this.parts[i];
        break;
      }
    }
  }

  changePartisipan(){
    var items: any;
    for (var i = 0; i < this.partisipan.length; i++) {
      if (this.partisipan[i].PA_ID == this.account.PARTISIPAN_ID) {
        items = this.partisipan[i];
        break;
      }
    }
  }

  showAccount(id: number, subtab: number) {
    var inst = 3;
    if (subtab == 2) {
      inst = 2;
    }
    this.modalAccount = true;
    this.newAccount();
    this.getParts(inst);
    if (id > 0) {
      this.http.get(Globals.serviceUrl + 'ritel/accounts?id=' + id + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
        .subscribe((res) => {
          this.account = res.json();
          // console.log(this.account);
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
        });
    }
  }
  saveAccount(subtab: number) {
    var inst = 3;
    if (subtab == 2) {
      inst = 2;
    }
    this.loading = true;
    this.account.INV_ID = this.investor.INV_ID;
    if (this.account.ACCT_ID == 0) {
      this.http.post(Globals.serviceUrl + 'ritel/accounts', this.account, { headers: this.headerService.getHeader() })
        .subscribe((res) => {
          this.account = res.json();
          this.toastr.success('Data berhasil disimpan');
          this.loading = false;
          this.getAccount(inst);
          this.modalAccount = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    } else {
      this.http.put(Globals.serviceUrl + 'ritel/accounts?id=' + this.account.ACCT_ID, this.account, { headers: this.headerService.getHeader() })
        .subscribe((res) => {
          this.account = res.json();
          this.toastr.success('Data berhasil disimpan');
          this.loading = false;
          this.getAccount(inst);
          this.modalAccount = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }

focusout(textValue: string) {
  if(textValue.length < 10){
    this.formActive = false;
      this.toastr.error('Error: Panjang SID minimal 12 character');
      this.loading = false;
  }
  else{
    this.http.get(Globals.serviceUrl + 'ritel/mastersid?sid=' + textValue, { headers: this.headerService.getHeader() })
    .subscribe((res: Response) => {
      this.mastersid = res.json();
      const invName = this.mastersid.FIRST_NAME != null? this.mastersid.FIRST_NAME: "";
      this.investor.INV_NAME = invName;
      const ktp = this.mastersid.KTP != null? this.mastersid.KTP: "";
      this.investor.IDTY_NO = ktp;
      const addr1 = this.mastersid.ADDRESS_1 != null? this.mastersid.ADDRESS_1: "";
      const addr2 =  this.mastersid.ADDRESS_2 != null? this.mastersid.ADDRESS_2: "";
      this.investor.ADDRESS = addr1 +' '+addr2 ;
      this.formActive = true;
    }, err => {
      console.log(err);
      // this.toastr.error(Globals.errorMessage(err));
      this.formActive = false;
      console.log(Globals.errorMessage(err));
      if(Globals.errorMessage(err) == '404'){
        this.toastr.error('Error ' + Globals.errorMessage(err) + '. SID tidak ditemukan.');
        this.loading = false;
      }
      else{
        this.toastr.error('Error ' + Globals.errorMessage(err) + '. Investor sudah ada.');    
        this.loading = false;    
      }      
      
    });
  }
}
  
}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/investor/investor-detail/investor-detail.component.ts